import { monteurApi } from '../common/monteur-api';
export var folderViewApi = monteurApi.injectEndpoints({
    endpoints: function (builder) { return ({
        getPaginatedFolderView: builder.query({
            query: function (req) {
                return {
                    url: "FolderView/get-paginated",
                    method: 'POST',
                    body: req
                };
            },
            providesTags: ['FolderView']
        }),
        getMachineDetailResult: builder.query({
            query: function (req) {
                return {
                    url: "FolderView/".concat(req),
                    method: 'GET'
                };
            }
        }),
        getFilesWithModel: builder.query({
            query: function (req) {
                var params = new URLSearchParams();
                if (req.searchText !== undefined)
                    params.append('SearchText', req.searchText.toString());
                if (req.machineId !== undefined)
                    params.append('MachineId', req.machineId.toString());
                if (req.modelNumber)
                    params.append('ModelNumber', req.modelNumber);
                return {
                    url: "FolderView/get-files-with-model?".concat(params.toString()),
                    method: 'GET'
                };
            }
        }),
        getFilesWithoutModel: builder.query({
            query: function (req) {
                var params = new URLSearchParams();
                if (req.searchText !== undefined)
                    params.append('SearchText', req.searchText.toString());
                if (req.machineId !== undefined)
                    params.append('MachineId', req.machineId.toString());
                return {
                    url: "FolderView/get-files-without-model?".concat(params.toString()),
                    method: 'GET'
                };
            },
            providesTags: ['OtherFolder']
        }),
        getModelOverviewByModelNumber: builder.query({
            query: function (req) {
                var params = new URLSearchParams();
                if (req.modelNumber !== undefined)
                    params.append('ModelNumber', req.modelNumber.toString());
                if (req.machineId !== undefined)
                    params.append('MachineId', req.machineId.toString());
                return {
                    url: "FolderView/model-overview?".concat(params.toString()),
                    method: 'GET'
                };
            }
        }),
        getDocumentsByModelNumber: builder.query({
            query: function (req) {
                var params = new URLSearchParams();
                if (req !== undefined)
                    params.append('MachineId', req);
                return {
                    url: "FolderView/documents-by-modelnumber?".concat(params.toString()),
                    method: 'GET'
                };
            },
            providesTags: ['ModelFolder']
        })
    }); }
});
export var useLazyGetPaginatedFolderViewQuery = folderViewApi.useLazyGetPaginatedFolderViewQuery, useLazyGetMachineDetailResultQuery = folderViewApi.useLazyGetMachineDetailResultQuery, useLazyGetFilesWithModelQuery = folderViewApi.useLazyGetFilesWithModelQuery, useLazyGetFilesWithoutModelQuery = folderViewApi.useLazyGetFilesWithoutModelQuery, useLazyGetModelOverviewByModelNumberQuery = folderViewApi.useLazyGetModelOverviewByModelNumberQuery, useLazyGetDocumentsByModelNumberQuery = folderViewApi.useLazyGetDocumentsByModelNumberQuery;
